// Vendor
import $ from 'jquery';
import Helper from '../helpers/util';

class Podcast {
	constructor(el) {
		this.$el = $(el);
		this.$episodes = this.$el.find('.elp-episode__iframe');
		this.players = [];

		this.$el.data('init', true);
		this.lastTimestamp = {};
		this.trackingInterval = 10; //sends a progress tracking for every 10second segment of an episode

		this.loadApi();
		this.attachEvents();
	}

	attachEvents() {
		this.$episodes.each((idx, el) => {
			const widget = window.SC.Widget(el);
			const episodeId = $(el).data('episode-id');
			this.lastTimestamp[episodeId];
			this.players.push(widget);
			widget.bind(window.SC.Widget.Events.FINISH, () => {
				const nextIFrame = this.$episodes.eq(idx + 1)[0];

				widget.getDuration(duration => {
					widget.pause();
					widget.seekTo(duration - 10); //set position 10ms before end, for visual
				});

				if (nextIFrame) {
					//Next Epsiode
					setTimeout(() => {
						const nextWidget = window.SC.Widget(nextIFrame);
						nextWidget.play();
					}, 2000);
				} else {
					//Last Episode
				}
			});
			widget.bind(window.SC.Widget.Events.READY, () => {
				//widget.seekTo(15000);
				fetch('/api/podcast/status/'+episodeId)
					.then(res => res.json())
					.then(json => {
						//console.log(`Progress: ${json.timestamp}`);
						widget.seekTo(json.timestamp * 1000);
					});
			});
			widget.bind(window.SC.Widget.Events.PLAY_PROGRESS, () => {
				widget.getPosition(position => {
					const segment =
						Math.floor(position / (1000 * this.trackingInterval)) *
						this.trackingInterval;
					if (this.lastTimestamp[episodeId] !== segment) {
						this.lastTimestamp[episodeId] = segment;
						this.sendListeningProgress(segment, episodeId);
					}
				});
			});
		});
	}

	sendListeningProgress(progress, episodeId) {
		// ajax call
		return new Promise(resolve => {
			const data = { id: episodeId, timestamp: progress };

			// Fetch token
			fetch('/session/token')
				.then(res => res.text())
				.then(token => {
					$.ajax({
						url: '/api/podcast/save',
						data: JSON.stringify(data),
						type: 'POST',
						dataType: 'json',
						contentType: 'application/json',
						headers: {
							'X-CSRF-Token': token
						},
						success: () => {
							resolve();
						},
						error: () => {
							resolve();
						}
					});
				});
		});
	}

	loadApi() {
		console.log(window.SC);
	}
}

const _init = () => {
	// Elements
	let $el = $('.elp-listing-episodes');
	if ($el.length) {
		$el.each((e, v) => {
			if (!$(v).data('init')) {
				new Podcast($(v));
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function() {
	_init();
});
